import React from 'react';
import { usePdfViewerContext } from '@cincel.digital/react';
import { Button, PopOver } from '@design-system/index';
import { DocumentSteps } from '@pages/DocumentPage/CreateDocument';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';

type BottomActionsProps = {
  /**
   * Primary color
   */
  primaryColor: string;
  /**
   * Current step
   */
  currentStep?: string;
  /**
   * Is button disabled
   */
  isButtonDisabled?: boolean;
  /**
   * Is Loading
   */
  isLoading?: boolean;
  /**
   * Disabled reasons
   */
  disabledReason?: any;
  /**
   * Is creating
   */
  hasFile?: boolean;
  /**
   * Handle step
   */
  handleSubmitDocument?: (step: string, data?: any) => void;
};

export function BottomActions({
  primaryColor,
  currentStep,
  isButtonDisabled,
  isLoading,
  disabledReason,
  hasFile = false,
  handleSubmitDocument,
}: BottomActionsProps) {
  const { getSigners, onClose, flatten } = usePdfViewerContext();
  const { t } = useTranslation();

  const handleSubmit = async (step) => {
    const file = await flatten();
    const signers = getSigners();
    handleSubmitDocument && handleSubmitDocument(step, { signers, file });
  };

  return (
    <div className="flex w-full flex-col">
      {hasFile && (
        <div className="mb-3 flex w-full pl-4">
          <Button
            className="ml-auto mr-10 mt-2"
            size="xs"
            variant="outline"
            onClick={onClose}
            color="#A5A5A5">
            {t(translations.COMMON.DELETE)}
          </Button>
        </div>
      )}
      {currentStep === DocumentSteps.share && (
        <div className="flex w-full justify-between">
          <div className="inline-block">
            <Button
              className="max-w mb-2 px-8 text-white"
              type="submit"
              variant="solid"
              color="#C4C4C4"
              onClick={() => handleSubmit(DocumentSteps.create)}
              size="sm">
              {t(translations.COMMON.BACK)}
            </Button>
          </div>
          <div className="flex justify-end">
            {isButtonDisabled ? (
              <PopOver
                position="top"
                content={
                  <>
                    <p>{t(disabledReason)}</p>
                  </>
                }>
                <Button
                  className="max-w mb-2 mr-8 px-8"
                  color={primaryColor}
                  isDisabled={isButtonDisabled}
                  type="submit"
                  onClick={() => handleSubmit(DocumentSteps.share)}
                  isLoading={isLoading}
                  size="sm">
                  {t(translations.COMMON.SEND)}
                </Button>
              </PopOver>
            ) : (
              <Button
                className="max-w mb-2 mr-8 px-8"
                color={primaryColor}
                isDisabled={isButtonDisabled}
                type="submit"
                onClick={() => handleSubmit(DocumentSteps.share)}
                isLoading={isLoading}
                size="sm">
                {t(translations.COMMON.SEND)}
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
